import React from 'react';
import { twMerge } from 'tailwind-merge';

function ModalBody(
    props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) {
    const { children, className, ...divProps } = props;

    return (
        <div
            {...divProps}
            className={twMerge('mt-3 rounded-md py-2 px-4', className)}
        >
            {children}
        </div>
    );
}

export default ModalBody;
